import React from 'react';
import { Box } from '@mui/material';
import { ButtonDefault } from '../../../shared/components/ButtonDefault';
import { openSnackbarAction } from '../../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../../shared/components/snackbar/snackbar-types';
import { UserInvitation, UserInvitationStatuses, UserRoles, useUpdateUserInvitationMutation } from '../../../shared/types/generated';
import { sanitizeUserRole } from '../../../shared/utils';

type TenantUserInvitationItemProps = {
  item: UserInvitation;
};
export const TenantUserInvitationItem: React.FC<TenantUserInvitationItemProps> = ({ item }) => {
  const [acceptedInvitation, { loading: acceptedLoading }] = useUpdateUserInvitationMutation({
    onCompleted: () => {
      openSnackbarAction('Se ha aceptado correctamente', TypeMessage.SUCCESS);
      window.location.reload();
    },
    onError: (error) => {
      openSnackbarAction(error.message, TypeMessage.ERROR);
    },
  });

  const [rejectedInvitation, { loading: rejectedLoading }] = useUpdateUserInvitationMutation({
    onCompleted: () => {
      openSnackbarAction('Se ha rechazado correctamente', TypeMessage.SUCCESS);
      window.location.reload();
    },
    onError: (error) => {
      openSnackbarAction(error.message, TypeMessage.ERROR);
    },
  });

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <div>
        Has sido invitado como {sanitizeUserRole(item.role as UserRoles)} al EasyData de Animal
        Politico.
      </div>
      <Box display="flex" alignItems="center" justifyContent="space-between" minWidth="200px">
        <ButtonDefault
          isLoading={rejectedLoading}
          onClick={() =>
            rejectedInvitation({
              variables: {
                data: {
                  id: item?.id as string,
                  status: UserInvitationStatuses.Rejected,
                },
              },
            })
          }
          variant="outlined"
          style={{
            height: 40,
            minWidth: 95,
          }}
        >
          REJECT
        </ButtonDefault>

        <ButtonDefault
          isLoading={acceptedLoading}
          onClick={() =>
            acceptedInvitation({
              variables: {
                data: {
                  id: item?.id as string,
                  status: UserInvitationStatuses.Accepted,
                },
              },
            })
          }
          style={{
            height: 40,
            minWidth: 95,
          }}
        >
          ACCEPT
        </ButtonDefault>
      </Box>
    </Box>
  );
};
